var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 38,
    rx: 4,
    fill: "#1B251A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5V24C9 25.1046 9.89543 26 11 26H25C26.1046 26 27 25.1046 27 24V17C27 15.8954 26.1046 15 25 15H10.5C9.67157 15 9 14.3284 9 13.5ZM9 13.5C9 12.6716 9.67013 12 10.4986 12H23C24.1046 12 25 12.8954 25 14V14.5M22.4 20.5H22.6M23 20.5C23 20.7761 22.7761 21 22.5 21C22.2239 21 22 20.7761 22 20.5C22 20.2239 22.2239 20 22.5 20C22.7761 20 23 20.2239 23 20.5Z",
    stroke: "#E8F2EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet4);
export default __webpack_public_path__ + "static/media/wallet-4.d89c62ab9c1ecfebe379a5ef59304076.svg";
export { ForwardRef as ReactComponent };